<template>
  <div class="row">
    <div class="col-md-12">
      <div class="cover profile">
        <div class="wrapper">
          <div class="image">
            <img
              v-if="previewList.length === 0"
              :src="bannerImage"
              alt="people"
              class="show-in-modal"
            />
            <img
              v-else
              v-for="(preview, index) in previewList"
              :key="index"
              :src="preview"
              class="show-in-modal"
              alt="banner"
            />
          </div>
          <div class="upload-banner">
            <form @submit.prevent="uploadBanner">
              <div>
                <div class="upload-banner-button">
                  <a>
                    <label for="banner-upload">
                      <i class="fa fa-camera"></i>
                    </label>
                    <input
                      ref="banner"
                      id="banner-upload"
                      type="file"
                      accept="image/*"
                      @change="previewImage"
                      style="display: none"
                    />
                  </a>
                  <button v-if="previewList.length !== 0" type="submit">
                    Apply
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="cover-info">
          <div class="avatar">
            <div class="item-img-wrap ">
              <img
                v-if="previewAvatarList.length === 0"
                :src="avatarImage"
                alt="people"
                class="img-circle"
              />
              <img
                v-else
                v-for="(preview, index) in previewAvatarList"
                :key="index"
                :src="preview"
                alt="people"
                class="img-circle"
              />
              <div class="item-img-overlay">
                <a href="#" class="show-image" @click.prevent="showImage(previewAvatarList.length === 0 ? '/img/Friends/guy-3.jpg' : previewAvatarList[0])">
                    <span></span>
                </a>
              </div>
            </div> 
            <div class="upload-avatar">
              <form @submit.prevent="uploadAvatar">
                <div>
                  <div class="upload-avatar-button">
                    <a>
                      <label for="avatar-upload">
                        <i class="fa fa-camera"></i>
                      </label>
                      <input
                        ref="avatar"
                        id="avatar-upload"
                        type="file"
                        accept="image/*"
                        @change="previewAvatarImage"
                        style="display: none"
                      />
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="name"><a href="#">{{ author.name }}</a></div>
          <ul class="cover-nav">
            <li :class="{ active: isActiveRoute('timeline') }">
              <router-link :to="{ name: 'timeline' }"
                ><i class="fa fa-fw fa-bars"></i> Timeline</router-link
              >
            </li>
            <li :class="{ active: isActiveRoute('about') }">
              <router-link :to="{ name: 'about' }"
                ><i class="fa fa-fw fa-user"></i> About</router-link
              >
            </li>
            <li :class="{ active: isActiveRoute('friend') }">
              <router-link :to="{ name: 'friend' }" append
                ><i class="fa fa-fw fa-users"></i> Friends</router-link
              >
            </li>
            <li :class="{ active: isActiveRoute('photo') }">
              <router-link :to="{ name: 'photo' }"
                ><i class="fa fa-fw fa-image"></i> Photos</router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade in" id="modalShow" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" :style="{ display: previewAvatarModal ? 'block' : 'none' }">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title" id="myModalLabel">Preview Avatar</h4>
        </div>
        <div class="modal-body text-centers">
          <img :src="modalImageSrc" class="img-responsive" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal" @click="uploadAvatar">Apply</button>
          <button type="button" class="btn btn-default" data-dismiss="modal" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const files = ref();
    const previewList = ref([]);
    const previewAvatarList = ref([]);
    const previewAvatarModal = ref(false);
    const modalImageSrc = ref('');
    const avatarImage = ref('/img/Friends/guy-3.jpg');
    const bannerImage = ref('/img/Cover/profile-cover.jpg');
    const author = ref({});
    const isActiveRoute = (routeName) => {
      return routeName === router.currentRoute.value.name;
    };
    function previewImage(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        files.value = input.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          previewList.value = [e.target.result];
        };
        reader.readAsDataURL(input.files[0]);
      }
    }
    async function uploadBanner() {
      try {
        await store.dispatch("profile/uploadBanner", {
          banner: files.value,
        });
        fetchProfile();
        previewList.value = [];
      } catch (error) {
        console.log(error);
      }
    }

    async function uploadAvatar() {
      try {
        await store.dispatch("profile/uploadAvatar", {
          avatar: files.value,
        });
        fetchProfile();
        previewAvatarList.value = [];
      } catch (error) {
        console.log(error);
      }
    }

    function previewAvatarImage(event) {
      const input = event.target;
      if (input.files && input.files[0]) {
        files.value = input.files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          previewAvatarList.value = [e.target.result];
        };
        reader.readAsDataURL(input.files[0]);
      }
    }
    function showImage(imgSrc) {
      modalImageSrc.value = imgSrc;
      previewAvatarModal.value = true;
    }
    function closeModal() {
      previewAvatarModal.value = false;
    }
    async function fetchProfile() {
      const profile = await store.dispatch("profile/fetchProfile", {
        userId: store.getters["auth/userId"],
      });
      if (profile.avatar) {
        avatarImage.value = `http://localhost:9000/story/${profile.avatar.image.filename}`;
      }
      if (profile.banner) {
        bannerImage.value = `http://localhost:9000/story/${profile.banner.image.filename}`;
      }
      if (profile.author) {
        author.value = profile.author;
      }
    }
    onMounted(async () => {
      fetchProfile();
    });
    return {
      files,
      author,
      showImage,
      closeModal,
      previewList,
      avatarImage,
      bannerImage,
      previewImage,
      uploadBanner,
      uploadAvatar,
      isActiveRoute,
      modalImageSrc,
      previewAvatarList,
      previewAvatarImage,
      previewAvatarModal,
    };
  },
};
</script>
<style scoped>
.image {
  display: flex;
  position: relative;
}
.upload-banner-button {
  display: flex;
  position: relative;
  justify-content: flex-end;
}
.upload-banner-button button {
  padding: 0 10px;
  margin: 0 5px;
  background-color: #fff;
  color: #000;
  border: 1px solid #ccc;
}

.upload-banner-button a {
  padding: 0 10px;
  margin: 0 5px;
  background-color: #fff;
  color: #000;
  border: 1px solid #ccc;
}

.upload-banner {
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 100%;
}
.upload-avatar {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 100%;
}
.upload-avatar-button {
  display: flex;
  position: relative;
  justify-content: flex-end;
}
.upload-avatar-button button {
  background-color: #fff;
  color: #000;
  border-radius: 50%;
  padding: 5px;
  border: 1px solid #ccc;
}
</style>